import { Input } from "@/components/ui/baseUi/input"
import { Label } from "@/components/ui/baseUi/label"
import { cn } from "@/modules/lib/utils"
import { type FieldValueChange } from "@/typings/formik"
import { type FieldInputProps } from "formik"

type StandardInsideInputProps<T, K> = {
  label?: string
  name: string
  setFieldValue: FieldValueChange<K>
  getFieldProps: (nameOrOptions: T) => FieldInputProps<any>
  error?: React.JSX.Element
  className?: string
  containerClassName?: string
  isValueHidden?: boolean
  inputProps?: React.ComponentProps<"input">
  children?: React.ReactNode
} & React.ComponentProps<"div">

export function StandardInsideInput<T, K>({
  label,
  name,
  setFieldValue,
  getFieldProps,
  error,
  className,
  containerClassName,
  isValueHidden,
  inputProps,
  children,
  ...props
}: StandardInsideInputProps<T, K>) {
  const value = getFieldProps(name as T).value || ""
  const textValue = isValueHidden ? "" : value

  return (
    <div className={cn("flex flex-col gap-2", className)} {...props}>
      <div className={cn("relative inline-flex flex-col gap-2", containerClassName)}>
        <Label variant="inside" htmlFor={name}>
          {label}
        </Label>
        <Input
          id={name}
          value={textValue}
          onChange={inputProps?.onChange ? inputProps.onChange : (v) => setFieldValue(name, v.target.value)}
          className={cn("bg-surface-background pr-4 text-right", inputProps?.className ?? "")}
          {...inputProps}
        />
        {children}
      </div>
      {error}
    </div>
  )
}
